//#region import
import React, { useEffect, useState } from 'react';
import { Button, Card, Grid, Typography } from '@mui/material';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { BtnAddProject, BtnClear, BtnSearch } from 'components/Button/ButtonAll';
import { APIStatusCode, EnumRegisterTimelineType, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { FormProvider, useForm } from 'react-hook-form';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { BtnApproveOnTable, BtnEditOnTable, BtnUpdateDataOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import { ApiProject } from 'enum/api';
import { TextBoxItem } from 'components/Input/TextBox';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { List as LINQ } from "linqts";
//#endregion

const ProjectList = () => {
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const DialogFn = FnDialog();
    const location = useLocation();

    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New

    const [isTableProject, setisTableProject] = useState(null); 
    const [isFastTrack, setisFastTrack] = useState(false); // true แบบเร่งด่วน | false แบบปกติ
    const [nRegisterTimelineID, setnRegisterTimelineID] = useState(false); //ID รอบ
    
    const [isPermission, setPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    const [loadingTable, setLoadingTable] = useState(false);   
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        arrRows: [
        ]
    });
    const [arrDataStatusID, setarrDataStatusID] = useState<any>([]);
    const [arrDataSectionTypeID, setarrDataSectionTypeID] = useState<any>([]);
    const [lstDataProject, setlstDataProject] = useState([]);
    const [isBtnAddProject, setisBtnAddProject] = useState(false); //ปุ่มสร้างรายการ
    const [isBtnSendSubCommittee, setisBtnSendSubCommittee] = useState(false); //ปุ่ม ส่งอนุกรรมการกลั่นกรองฯ ลงคะแนน > เปิดตอนเป็น เลขา
    
    const [sStartDate, setsStartDate] = useState(null);
    const [sEndDate, setsEndDate] = useState(null);    
    const [sTime, setsTime] = useState(null);    
    const [ObjExampleFile, setObjExampleFile] = useState(null);

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sProjectName: null,
            arrSectionTypeID: null,
            arrStatusID: null,
            dStartDate: null, //_dStart,
            dEndDate: null, // _dEnd,
        } as any,
    });

    useEffect(() => {       
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        GetFormInitialList();      
    }, []);

    const GetFormInitialList = () => {
        AxiosFn.Get(ApiProject.GetFormInitialList, {}, (result) => {
            setisBtnAddProject(result.isBtnAddProject); 
            setisBtnSendSubCommittee(result.isBtnSendSubCommittee);
            setsStartDate(result.ObjRegisterTimeline?.sStartDate);
            setsEndDate(result.ObjRegisterTimeline?.sEndDate);
            setsTime(result.ObjRegisterTimeline?.sTime);
            setisFastTrack(result.ObjRegisterTimeline?.isFastTrack);
            setnRegisterTimelineID(result.ObjRegisterTimeline?.nRegisterTimelineID);          
            setarrDataSectionTypeID(result.lstSectionTypeID);
            form.setValue("arrSectionTypeID", result.lstSectionTypeID.map(m => m.value));
            setarrDataStatusID(result.lstStatusID);
            form.setValue("arrStatusID", result.lstStatusID.map(m => m.value));
            setObjExampleFile(result.ObjExampleFile);
            handleGetTableProject(dataRow, true);
        });
    }

    const handleGetTableProject = (p: PaginationInterface, isGetForm) => {
        setLoadingTable(true);
        let ObjForm = form.getValues();
        let nDate_Start = ObjForm.dStartDate ? ObjForm.dStartDate.valueOf() : null;
        let nDate_End = ObjForm.dEndDate ? ObjForm.dEndDate.valueOf() : null;
        let objParam = {
            ...p,
            sProjectName: ObjForm.sProjectName ?? null,
            lstSectionTypeID: ObjForm.arrSectionTypeID ?? [],
            lstStatusID: ObjForm.arrStatusID ?? [],
            nStartDate: nDate_Start,
            nEndDate: nDate_End,
        };
        AxiosFn.Post(ApiProject.GetTableProject, objParam, (result) => {
            setLoadingTable(false);
            if (result.nStatusCode === APIStatusCode.Success) 
            {
                if (isGetForm) setisTableProject(result.lstDataProject.length > 0);
                setlstDataProject(result.lstDataProject ?? []);
                setDataRow({
                    ...p,
                    arrRows: result.lstDataProject ?? [],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    };

    const goToEdit = (sID: string, sMode: string) => {
        let sUrl = "/ProjectsRequestingFrom";
        // navigate(sUrl, { state: { sID: sID, sMode: sMode, sRegisterTimelineType: (isFastTrack ? EnumRegisterTimelineType.FastTrack : EnumRegisterTimelineType.Normal), sModeSecretary: false, sPathNameBack: "/ProjectList" } });
        navigate(sUrl, { state: 
                            { 
                                sID: sID, 
                                sMode: sMode, 
                                sRegisterTimelineType: (isFastTrack ? EnumRegisterTimelineType.FastTrack : EnumRegisterTimelineType.Normal), 
                                nRegisterTimelineID: nRegisterTimelineID,
                                sModeSecretary: false, 
                                sPathNameBack: "/ProjectList",
                            }
                        }
                );
    };

    const dataColumn: any = [
        {
            field: "isBtnEdit",
            headerName: `${I18n.SetText("Project.sManagement")}`,
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            disableReorder: true,
            width: 100,
            getActions: (item) => {
                return [
                    <>
                        {isPermission ? 
                            <>
                                {item.row.isBtnUpdate ?
                                    <BtnUpdateDataOnTable
                                        key={item.row.sID}
                                        id="btnUpdateProgress"
                                        onClick={() => goToEdit(item.row.nProjectID, "UpdateProgress")}
                                        IsDisabled={!isPermission}
                                    />
                                    :
                                    (item.row.isBtnPresent &&
                                        <BtnApproveOnTable
                                            key={item.row.sID}
                                            id="btnPresent"
                                            txt={item.row.nSectionTypeID === 38 ? "สื่อเผยแพร่และประชาสัมพันธ์" : "นำเสนอวิชาการ/ตีพิมพ์"}
                                            onClick={() => goToEdit(item.row.nProjectID, "Present")}
                                            IsDisabled={!isPermission}
                                        />
                                    )
                                }
                                {item.row.isBtnEdit ?
                                        <BtnEditOnTable
                                            key={item.row.sID}
                                            id="btnEdit"
                                            onClick={() => goToEdit(item.row.nProjectID, "Edit" )}
                                            IsDisabled={!isPermission}
                                        />
                                    :
                                    <BtnViewDataOnTable
                                        key={item.row.sID}
                                        id="btnView"
                                        onClick={() => goToEdit(item.row.nProjectID, "View")}
                                        // IsDisabled={isPermission}
                                    />
                                }
                            </>
                        : 
                            <BtnViewDataOnTable
                                key={item.row.sID}
                                id="btnView"
                                onClick={() => goToEdit(item.row.nProjectID, "View")}
                                // IsDisabled={isPermission}
                            />                        
                        }
                    </>
                ];
            },
        },
        {
            field: "sStatusTableName", //"sStatusName",
            headerName: `${I18n.SetText("Project.sStatus")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 3,
            // renderCell: (item) => {       
            //     return (item.row.nProgressStatusID ? item.row.sProgressStatus : item.row.sStatusName);
            // }
        },
        {
            field: "sProjectName",
            headerName: `${I18n.SetText("Project.sProjectName")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            disableReorder: true,
            flex: 5,
        },
        {
            field: "sSectionType",
            headerName: `${I18n.SetText("Project.sProjectType")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
        {
            field: "sRegisterDate",
            headerName: `${I18n.SetText("Project.sDateRegister")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
        {
            field: "sApproveDate",
            headerName: `${I18n.SetText("Project.sDateApprover")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
    ];

    const onExample = (ObjExampleFile) => {
        // โหลดไฟล์เปิดมาอีกแท็บ
        if(ObjExampleFile?.sPathFile && ObjExampleFile?.sFileName) {
            window.open(ObjExampleFile?.sPathFile, "_blank", 'noopener,noreferrer');
        }
    }

    const onDelete = (e) => {
        let ObjDelete = {
            lstID: e,
            sLocation: location.pathname,
        }
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            setLoadingTable(true);
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.DeleteProject, ObjDelete, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => { 
                        handleGetTableProject(dataRow, false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <React.Fragment>
            {/* {dataRow.arrRows.length === 0 ? */}
            {isTableProject === false ?
                    <Grid item container spacing={2} xs={12} md={12} style={{ textAlign: 'center', padding: '1%', }}>
                        <Grid item xs={12} md={12}>
                            <Card style={{ backgroundColor: "#ffeeee" }}>
                                <Grid item container spacing={2} xs={12} md={12} style={{ textAlign: 'center', padding: '3%', }} justifyContent={'center'}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant='h4' style={{ margin: "1%", color: '#710d0d' }}>กองทุนจัดการซากดึกดำบรรพ์ เพิ่มความสะดวกในการขอรับการสนับสนุนเงินอุดหนุนจากกองทุนจัดการซากดึกดำบรรพ์</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Typography variant='h6' style={{ padding: "0.5%", backgroundColor: '#710d0d', color: 'white', }}>ผู้ขอรับเงินสนับสนุนสามารถใช้บริการยื่นข้อเสนอโครงการผ่านทางระบบ ได้อย่างสะดวก รวดเร็ว และครบถ้วน</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                        <Button variant="text" startIcon={<AutoStoriesIcon/>} onClick={(e) => { onExample(ObjExampleFile) }} ><Typography style={{textDecoration: 'underline', cursor: 'pointer', fontSize: '16px'}} gutterBottom>{I18n.SetText("Project.sInstructionManual")}</Typography></Button>
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                        {isPermission && <BtnAddProject id={"btnAddProject"} IsDisabled={!isBtnAddProject || !isPermission} txt={I18n.SetText("Button.AddProject", I18NextNs.labelComponent)} onClick={(e) => { navigate("/ProjectsRequestingFrom"); }} /> }
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ display: (!isBtnAddProject ? 'none' : "")}}>
                                        <Typography variant='inherit'>ระยะเวลาการยื่นข้อเสนอโครงการ</Typography>
                                    </Grid>
                                    <Grid item container spacing={1} xs={12} md={12} style={{ textAlign: 'center', paddingBottom: '2%', display: (!isBtnAddProject ? 'none' : "")}} justifyContent={'center'} >
                                        <Grid item>
                                            <Typography variant='inherit'>เปิด วันที่</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant='inherit' color={'red'}>{sStartDate}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant='inherit'>ถึงวันที่</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant='inherit' color={'red'}>{sEndDate}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant='inherit'>เวลา</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant='inherit' color={'red'}>{sTime}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant='inherit'>น.</Typography>
                                        </Grid>
                                        {/* <Typography variant='inherit'>{"เปิด วันที่ " + <p color={'#710d0d'}>"1 พ.ค. 2566 "</p> + " ถึงวันที่ " + <p color={'#710d0d'}>"31 พ.ค. 2566"</p> + " เวลา " + <p color={'#710d0d'}>"23.59"</p> + " น."}</Typography> */}
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                : isTableProject === true ?
                    <Grid item container spacing={2} xs={12} md={12} style={{ padding: '1%', }} >
                        <Grid item container spacing={1} xs={12} md={12} justifyContent={'flex-start'} justifyItems={'flex-start'} alignItems={'center'}>
                            <Grid item xs={12} md={2}>
                                <Button variant="text" startIcon={<AutoStoriesIcon/>} onClick={(e) => { onExample(ObjExampleFile) }} ><Typography style={{textDecoration: 'underline', cursor: 'pointer', fontSize: '16px'}} gutterBottom>{I18n.SetText("Project.sInstructionManual")}</Typography></Button>
                            </Grid>                                              
                            <Grid item container spacing={2} xs={12} md={10} style={{ display: (!isBtnAddProject ? 'none' : "")}} justifyContent={'end'} alignItems={'center'}>
                                <Grid item container spacing={1} xs={12} md={9.8} style={{ textAlign: 'center'}} justifyContent={'end'} alignItems={'center'} >
                                    <Grid item>
                                        <Typography variant='inherit'>ระยะเวลาการยื่นข้อเสนอโครงการ วันที่</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='inherit' color={'red'}>{sStartDate}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='inherit'>ถึงวันที่</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='inherit' color={'red'}>{sEndDate}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='inherit'>เวลา</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='inherit' color={'red'}>{sTime}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='inherit'>น.</Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={2.2} container spacing={1} justifyContent={'end'} alignItems={'center'}>
                                    {isPermission && <BtnAddProject id={"btnAddProject"} IsDisabled={!isBtnAddProject || !isPermission} txt={I18n.SetText("Button.AddProject", I18NextNs.labelComponent)} onClick={(e) => { navigate("/ProjectsRequestingFrom"); }} /> }
                                </Grid>
                            </Grid>                        
                        </Grid>
                        <Grid item container spacing={2} xs={12} md={12} justifyItems={'end'} justifyContent={'end'} alignItems={'end'}>
                            <FormProvider {...form}>
                                <Grid item xs={12} md={6}>
                                    <TextBoxItem
                                        id={"sProjectName"}
                                        name={"sProjectName"}
                                        label={`${I18n.SetText("Project.sProjectName")}`}
                                        required={false}    
                                        maxLength={250}           
                                    />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <MultipleSelectItem
                                        id={"arrSectionTypeID"}
                                        name={"arrSectionTypeID"}
                                        label={`${I18n.SetText("Project.sProjectType")}`}
                                        required={false}
                                        options={arrDataSectionTypeID}    
                                        disabled={false}   
                                        limitTag={2}                       
                                    />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <MultipleSelectItem
                                        id={"arrStatusID"}
                                        name={"arrStatusID"}
                                        label={`${I18n.SetText("Project.sStatus")}`}
                                        required={false}
                                        options={arrDataStatusID}       
                                        disabled={false}      
                                        limitTag={1}                 
                                    />
                                </Grid>                
                                <Grid item xs={12} md={5} container spacing={1}>
                                    <Grid item xs={11} md={5.8}>
                                        <DatePickerItem
                                            name={"dStartDate"}
                                            id={"dStartDate"}
                                            label={`${I18n.SetText("Project.sStartDate")}`}
                                            fullWidth={true}
                                            required={false}
                                            disabled={false}  
                                            maxDate={form.watch("dEndDate")}
                                        />
                                    </Grid>
                                    <Grid item style={{marginTop: '2%'}}> - </Grid>
                                    <Grid item xs={11} md={5.8}>
                                        <DatePickerItem
                                            name={"dEndDate"}
                                            id={"dEndDate"}
                                            label={`${I18n.SetText("Project.sEndDate")}`}
                                            fullWidth={true}
                                            required={false}
                                            disabled={false}  
                                            minDate={form.watch("dStartDate")}
                                        />
                                    </Grid>
                                </Grid>   
                                <Grid item xs={12} md={1} container spacing={1} justifyItems={'end'} justifyContent={'flex-start'}> 
                                    <Grid item>
                                        <BtnClear 
                                            id={'btnClearSearchAll'} 
                                            IsCircleWithOutText={true} 
                                            onClick={()=> { 
                                                form.reset();
                                                form.setValue("arrSectionTypeID", arrDataSectionTypeID.map(m => m.value));
                                                form.setValue("arrStatusID", arrDataStatusID.map(m => m.value));
                                            }} 
                                        />
                                    </Grid>
                                    <Grid item>
                                        <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true} onClick={()=> { handleGetTableProject(dataRow, false); }} />
                                    </Grid>
                                </Grid>
                            </FormProvider>              
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <DataGrid
                                sTableID='TB_Project'
                                isLoading={loadingTable}
                                columns={dataColumn}
                                rows={dataRow}
                                onLoadData={(e) => { handleGetTableProject(e, false) }}
                                isHiddenToolHead={true}
                                isShowCheckBox={isPermission}
                                onRowSelectable={(p) => p.row.isBtnDel}
                                onDelete={(d) => onDelete(d)}
                            />
                        </Grid>
                    </Grid>
                : <Grid style={{ paddingBottom: '30%', }}></Grid>
            }
        </React.Fragment>
    )
}
export default ProjectList;
